// extracted by mini-css-extract-plugin
export var active = "StepsContainer-module--active--47319";
export var appear = "StepsContainer-module--appear--9c08c";
export var container = "StepsContainer-module--container--66557";
export var contentWrapper = "StepsContainer-module--contentWrapper--29721";
export var fadeInAnimation = "StepsContainer-module--fadeInAnimation--90cef";
export var step = "StepsContainer-module--step--4569e";
export var stepsWrapper = "StepsContainer-module--stepsWrapper--7ecb6";